module.exports = __webpack_public_path__ + "img/video.cd7d6389.svg";